import { GenerateKeyRequestDto } from 'src/app/shared/services/api/dto/generate-key-request-dto';

export enum CreateCryptoTokenKeyField {
  alias = 'alias',
  keySpecification = 'keySpecification',
}

export interface CreateCryptoTokenKeyFormValue {
  [CreateCryptoTokenKeyField.alias]?: string | null;
  [CreateCryptoTokenKeyField.keySpecification]?: string | null;
}

// formValue is assumed valid.  Validation is performed by the form.
export function cryptoTokenKeyFormValueToDto(
  formValue: CreateCryptoTokenKeyFormValue,
): GenerateKeyRequestDto {
  return {
    alias: formValue[CreateCryptoTokenKeyField.alias] ?? '',
    keySpecification:
      formValue[CreateCryptoTokenKeyField.keySpecification] ?? '',
  };
}
